import axios from 'axios';
import { useKeycloakStore } from '../pinia-stores/keycloak.js';

const baseURL = import.meta.env.VITE_APP_URL;

export const api = axios.create({
  baseURL,
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const store = useKeycloakStore();
  if (store.token) {
    config.headers.Authorization = `Bearer ${store.token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      try {
        import("../session-expiry.js").then((m) => m.markSessionExpiry()).catch(() => {});
        import("../pinia-stores/keycloak.js").then((m) => {
          const store = m.useKeycloakStore();
          try { store.forceLocalLogout(); } catch {}
        }).catch(() => {});
      } catch {}
    }
    return Promise.reject(err);
  }
);

export default api;
